interface SmeStatusFilterProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  name?: string;
}

export default function SmeStatusFilter({ value, onChange, name = "is_sme" }: SmeStatusFilterProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300">
        SME Status
      </label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="block w-full px-3 py-2 text-sm rounded-lg border border-zinc-300 bg-white text-zinc-900 placeholder:text-zinc-400 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
      >
        <option value="">All Companies</option>
        <option value="true">SME Only</option>
        <option value="false">Non-SME Only</option>
      </select>
    </div>
  );
} 